import {Injectable} from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';

@Injectable()
export class KendoDialogService {

    constructor(private dialogService: DialogService) {}

    //Opens a dialog window on the screen with the given title and message
    //Returns an observable that return true if the user selects yes, false otherwise
    showConfirmation(title: string, contents: string): Observable<boolean> {
        return new Observable<boolean>((observer: any) => {
            const dialog: DialogRef = this.dialogService.open({
                title: title,
                content: contents,
                width: 450,
                height: 200,
                minWidth: 250,
                actions: [
                    {text: 'No'},
                    {text: 'Yes', primary: true}
                ]
            });

            dialog.result.subscribe((result: any) => {
                if(result.text === 'Yes' ) {
                    observer.next(true);
                } else {
                    observer.next(false);
                }
                observer.complete();
            });
        });
    }
}